<template>
  <div class="box19">
    <pageTitle title="免费视频教程<br />专为Python+大数据开发学子打造" />

    <div class="margin-box">
      <commonFreeVideo :videoList="videoList" pageName="Python+大数据" />
    </div>

    <div class="btn" @click="zixun('获取更多')">
      获取更多
      <span>></span>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commonFreeVideo from "../common/common-free-video.vue";
export default {
  components: {
    pageTitle,
    commonFreeVideo,
  },
  data() {
    return {
      videoList: [
        {lessonName:"手撕面试官搞定MySQL索引",
          url: "https://m.boxuegu.com/freecourse/detail-5284",
          img: require("../../../assets/coursePage/pythonData/box19/01.png"),
        },
        {lessonName:"大数据如何割韭菜",
          url: "https://m.boxuegu.com/freecourse/detail-5273",
          img: require("../../../assets/coursePage/pythonData/box19/02.png"),
        },
        {lessonName:"成为Apache贡献者从第一个PR开始",
          url: "https://m.boxuegu.com/freecourse/detail-5256",
          img: require("../../../assets/coursePage/pythonData/box19/03.png"),
        },
        {lessonName:"大数据行业深度解读",
          url: "https://m.boxuegu.com/freecourse/detail-5223",
          img: require("../../../assets/coursePage/pythonData/box19/04.png"),
        },

        {lessonName:"实现千亿级数据存储和快速查询的案例实践",
          url: "https://m.boxuegu.com/freecourse/detail-4244",
          img: require("../../../assets/coursePage/pythonData/box19/05.png"),
        },
        {lessonName:"用户行为分析类产品架构解密",
          url: "https://m.boxuegu.com/live/detail-1396",
          img: require("../../../assets/coursePage/pythonData/box19/06.png"),
        },
        {lessonName:"大数据Hadoop入门教程",
          url: "https://m.boxuegu.com/freecourse/detail-1091",
          img: require("../../../assets/coursePage/pythonData/box19/07.png"),
        },
        {lessonName:"云计算大数据Zookeeper教程",
          url: "https://m.boxuegu.com/freecourse/detail-1093",
          img: require("../../../assets/coursePage/pythonData/box19/08.png"),
        },
      ],
    };
  },
  methods: {
    zixun(name) {
      this.mai("Python+大数据","获取更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
.box19 {
  padding: 80px 0px 88px;
  width: 100%;

  .margin-box {
    margin-top: 48px;
  }

  .btn {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #165dff;
  }
}
</style>
